<script>
import compoment from '@/components/draggable/SmartComponents/basicComponents/Sinput/SInputEditor'
export default {
  name: 'SAgeEditor',
  extends: compoment
}
</script>
